export default {
	setItems(state, payload) {
		state.items.push(...payload)
	},
	setNextPageIndex(state, payload) {
		state.next_page_index = payload
	},
}